var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11854",
    "data-name": "Group 11854",
    transform: "translate(492.946 284) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(482.946 274)",
    fill: "#4a90f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M6727.581,281.886l-2,1.964,2,2.036",
    transform: "translate(-6238.935 -5.062)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpRedirect);
export default __webpack_public_path__ + "static/media/op-redirect.bea37f9a914d4842d6c41c03fa331fe7.svg";
export { ForwardRef as ReactComponent };